import { MultipleSelectComponent } from 'src/app/components/multiple-select/multiple-select.component';
import { BQSqlFunctionHelper } from 'src/app/utils/datasource-sql-map/bq-sql-function-helper';
import { IDatasourceSQLMap } from 'src/app/utils/datasource-sql-map/datasource';
import { DatasourceSpecificColumnsSQLStatementsCompiler } from 'src/app/utils/datasource-sql-map/datasource-specific-sql-statements-compiler';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import {
    multipleSelectComponentCompileSQLTokens,
    segmentContainerIdCompileSQLTokens,
} from 'src/app/utils/datasource-sql-map/utils';

export class BIVizDashboardSales {
    // getter for sqlMap
    public static get sqlMap() {
        const sqlMap: IDatasourceSQLMap = {
            dataset: 'bi_viz',
            tableId: 'dashboard_sales',
            columns: {
                SALES_INAPP_SOURCE: {
                    columnId: 'SALES_INAPP_SOURCE',
                    columnSQL: 'inapp_offer_hierarchy.unified_source',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.unified_source',
                            state
                        );
                    },
                },
                SALES_OFFER_NAME: {
                    columnId: 'SALES_OFFER_NAME',
                    columnSQL: 'inapp_offer_hierarchy.offer_name',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_name',
                            state
                        );
                    },
                },
                SALES_OFFER_TYPE: {
                    columnId: 'SALES_OFFER_TYPE',
                    columnSQL: 'inapp_offer_hierarchy.offer_type',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_type',
                            state
                        );
                    },
                },
                SALES_OFFER_SEGMENT: {
                    columnId: 'SALES_OFFER_SEGMENT',
                    columnSQL: 'inapp_offer_hierarchy.offer_segment',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_segment',
                            state
                        );
                    },
                },
                SALES_OFFER_SEASON: {
                    columnId: 'SALES_OFFER_SEASON',
                    columnSQL: 'inapp_offer_hierarchy.offer_season',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_season',
                            state
                        );
                    },
                },
                SALES_OFFER_SEASON_VARIANT: {
                    columnId: 'SALES_OFFER_SEASON_VARIANT',
                    columnSQL: 'inapp_offer_hierarchy.offer_season_variant',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_season_variant',
                            state
                        );
                    },
                },
                SALES_OFFER_SEASON_SIZE: {
                    columnId: 'SALES_OFFER_SEASON_SIZE',
                    columnSQL: 'inapp_offer_hierarchy.offer_season_size',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_offer_hierarchy.offer_season_size',
                            state
                        );
                    },
                },
                SALES_INAPP_TRANSACTION_NO_BUCKET: {
                    columnId: 'SALES_INAPP_TRANSACTION_NO_BUCKET',
                    columnSQL: 'inapp_transaction_no_bucket.label',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_transaction_no_bucket.label',
                            state
                        );
                    },
                },
                SALES_INAPP_TRANSACTION_NO_BUCKET_SORT_KEY: {
                    columnId: 'SALES_INAPP_TRANSACTION_NO_BUCKET_SORT_KEY',
                    columnSQL: 'inapp_transaction_no_bucket.sort_key',
                    compileSQLTokens: (state) => {
                        throw new Error(
                            'SORT KEY column should not be used in filters or splits'
                        );
                    },
                },
                SALES_INAPP_TRANSACTION_NO_LABEL: {
                    columnId: 'SALES_INAPP_TRANSACTION_NO_LABEL',
                    columnSQL: 'inapp_transaction_no_label',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_transaction_no_label',
                            state
                        );
                    },
                },
                SALES_INAPP_PRODUCT_ID: {
                    columnId: 'SALES_INAPP_PRODUCT_ID',
                    columnSQL: 'inapp_product_id',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_product_id',
                            state
                        );
                    },
                },
                SALES_INAPP_PRODUCT_ID_PRICE_TIER: {
                    columnId: 'SALES_INAPP_PRODUCT_ID_PRICE_TIER',
                    columnSQL: 'inapp_product_id_price_tier',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_product_id_price_tier',
                            state
                        );
                    },
                },
                SALES_INAPP_PRODUCT_NAME: {
                    columnId: 'SALES_INAPP_PRODUCT_NAME',
                    columnSQL: 'inapp_product_name',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'inapp_product_name',
                            state
                        );
                    },
                },
                AD_PLATFORM: {
                    columnId: 'AD_PLATFORM',
                    columnSQL: 'ad_platform',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'ad_platform',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD: {
                    columnId: 'ATTRIBUTION_AD',
                    columnSQL: 'player_dim.attribution.unified_ad',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_LENGTH_S: {
                    columnId: 'ATTRIBUTION_AD_LENGTH_S',
                    columnSQL: 'player_dim.attribution.unified_ad_dim.length_s',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.length_s',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_SIZE: {
                    columnId: 'ATTRIBUTION_AD_SIZE',
                    columnSQL: 'player_dim.attribution.unified_ad_dim.size',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.size',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_ASPECT_RATIO: {
                    columnId: 'ATTRIBUTION_AD_ASPECT_RATIO',
                    columnSQL:
                        'player_dim.attribution.unified_ad_dim.aspect_ratio',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.aspect_ratio',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_TYPE: {
                    columnId: 'ATTRIBUTION_AD_TYPE',
                    columnSQL: 'player_dim.attribution.unified_ad_dim.type',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.type',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_THEME: {
                    columnId: 'ATTRIBUTION_AD_THEME',
                    columnSQL: 'player_dim.attribution.unified_ad_dim.theme',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.theme',
                            state
                        );
                    },
                },
                ATTRIBUTION_AD_VERSION: {
                    columnId: 'ATTRIBUTION_AD_VERSION',
                    columnSQL: 'player_dim.attribution.unified_ad_dim.version',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_ad_dim.version',
                            state
                        );
                    },
                },
                ATTRIBUTION_ADSET: {
                    columnId: 'ATTRIBUTION_ADSET',
                    columnSQL: 'player_dim.attribution.unified_adset',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_adset',
                            state
                        );
                    },
                },
                ATTRIBUTION_CAMPAIGN_ACTIVE: {
                    columnId: 'ATTRIBUTION_CAMPAIGN_ACTIVE',
                    columnSQL: 'active_campaign',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.active_campaign',
                            state,
                            MultipleSelectComponent.toBooleanSQL
                        );
                    },
                },
                ATTRIBUTION_CAMPAIGN_NAME: {
                    columnId: 'ATTRIBUTION_CAMPAIGN_NAME',
                    columnSQL: 'player_dim.attribution.unified_campaign',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_campaign',
                            state
                        );
                    },
                },
                ATTRIBUTION_TRAFFIC_SOURCE: {
                    columnId: 'ATTRIBUTION_TRAFFIC_SOURCE',
                    columnSQL: 'player_dim.attribution.unified_traffic',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_traffic',
                            state
                        );
                    },
                },
                ATTRIBUTION_NETWORK_NAME: {
                    columnId: 'ATTRIBUTION_NETWORK_NAME',
                    columnSQL: 'player_dim.attribution.unified_network',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.attribution.unified_network',
                            state
                        );
                    },
                },
                DAILY_TOTAL_ENERGY_SPENT: {
                    columnId: 'DAILY_TOTAL_ENERGY_SPENT',
                    columnSQL: 'energy_outflow_running_group',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'energy_outflow_running_group',
                            state
                        );
                    },
                },
                FIREBASE_APP_STORE: {
                    columnId: 'FIREBASE_APP_STORE',
                    columnSQL: 'player_dim.revenue_sessions.first_store',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.revenue_sessions.first_store',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_EUROPEAN_UNION: {
                    columnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
                    columnSQL: 'player_dim.geo.first_geo.country_european_union',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.geo.first_geo.country_european_union',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_TIER: {
                    columnId: 'FIREBASE_COUNTRY_TIER',
                    columnSQL: 'player_dim.geo.first_geo.country_tier_label',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.geo.first_geo.country_tier_label',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_IS_RELEVANT_LABEL: {
                    columnId: 'FIREBASE_COUNTRY_IS_RELEVANT_LABEL',
                    columnSQL:
                        'player_dim.geo.first_geo.country_is_relevant_label',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.geo.first_geo.country_is_relevant_label',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY: {
                    columnId: 'FIREBASE_COUNTRY',
                    columnSQL: 'player_dim.geo.first_geo.unified_country',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.geo.first_geo.unified_country',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_US_REGION: {
                    columnId: 'FIREBASE_COUNTRY_US_REGION',
                    columnSQL: 'player_dim.geo.first_geo.us_subdivision',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.geo.first_geo.us_subdivision',
                            state
                        );
                    },
                },
                FIREBASE_FIRST_OPEN_DATE: {
                    columnId: 'FIREBASE_FIRST_OPEN_DATE',
                    columnSQL: 'player_dim.revenue_sessions.first_session_date',
                    compileSQLTokens: (state) => {
                        return DatePickerSqlTokensCompiler.compileTokens(
                            'player_dim.revenue_sessions.first_session_date',
                            state
                        );
                    },
                },
                ETL_PAYER: {
                    columnId: 'ETL_PAYER',
                    columnSQL: 'player_dim.revenue_sessions.payer_label',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.revenue_sessions.payer_label',
                            state
                        );
                    },
                },
                ETL_REVENUE_BADGE: {
                    columnId: 'ETL_REVENUE_BADGE',
                    columnSQL: 'player_dim.revenue_sessions.revenue_badge',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.revenue_sessions.revenue_badge',
                            state
                        );
                    },
                },
                FIREBASE_INSTALL_VERSION: {
                    columnId: 'FIREBASE_INSTALL_VERSION',
                    columnSQL: 'player_dim.revenue_sessions.install_version',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'player_dim.revenue_sessions.install_version',
                            state
                        );
                    },
                },
                FIREBASE_INSTALL_VERSION_GROUP_MINOR: {
                    columnId: 'FIREBASE_INSTALL_VERSION_GROUP_MINOR',
                    columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                        BQSqlFunctionHelper.VERSION_HIERARCHY,
                        ['player_dim.revenue_sessions.install_version']
                    )}.minor`,
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            `${BQSqlFunctionHelper.getCallSqlStatement(
                                BQSqlFunctionHelper.VERSION_HIERARCHY,
                                ['player_dim.revenue_sessions.install_version']
                            )}.minor`,
                            state
                        );
                    },
                },
                ACTIVITY_DATE: {
                    columnId: 'ACTIVITY_DATE',
                    columnSQL: 'date',
                    compileSQLTokens: (state) => {
                        return DatePickerSqlTokensCompiler.compileTokens(
                            'date',
                            state
                        );
                    },
                },
                ACTIVITY_APP_VERSION_GROUP_MINOR: {
                    columnId: 'ACTIVITY_APP_VERSION_GROUP_MINOR',
                    columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                        BQSqlFunctionHelper.VERSION_HIERARCHY,
                        ['app_version']
                    )}.minor`,
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            `${BQSqlFunctionHelper.getCallSqlStatement(
                                BQSqlFunctionHelper.VERSION_HIERARCHY,
                                ['app_version']
                            )}.minor`,
                            state
                        );
                    },
                },
                ACTIVITY_APP_VERSION: {
                    columnId: 'ACTIVITY_APP_VERSION',
                    columnSQL: 'app_version',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'app_version',
                            state
                        );
                    },
                },
                ACTIVITY_DAY_NO: {
                    columnId: 'ACTIVITY_DAY_NO',
                    columnSQL: 'day_no',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'day_no',
                            state
                        );
                    },
                },
                SEGMENT: {
                    columnId: 'SEGMENT',
                    columnSQL: 'segments',
                    compileSQLTokens: segmentContainerIdCompileSQLTokens,
                },
                SEGMENT_EXCLUDE: {
                    columnId: 'SEGMENT_EXCLUDE',
                    columnSQL: 'segments',
                    compileSQLTokens: segmentContainerIdCompileSQLTokens,
                },
            },
        };
        return sqlMap;
    }

    public static get sqlStatementsCompiler() {
        return new DatasourceSpecificColumnsSQLStatementsCompiler({
            sqlMap: BIVizDashboardSales.sqlMap,
            specificColumns: [
                'SALES_INAPP_SOURCE',
                'SALES_INAPP_PRODUCT_ID',
                'SALES_INAPP_PRODUCT_ID_PRICE_TIER',
                'SALES_INAPP_PRODUCT_NAME',
                'SALES_INAPP_TRANSACTION_NO_BUCKET',
                'SALES_INAPP_TRANSACTION_NO_LABEL',
                'SALES_OFFER_NAME',
                'SALES_OFFER_TYPE',
                'SALES_OFFER_SEGMENT',
                'SALES_OFFER_SEASON',
                'SALES_OFFER_SEASON_VARIANT',
                'SALES_OFFER_SEASON_SIZE',
                'AD_PLATFORM',
            ],
            datasourcePrefix: 'revenue',
        });
    }
}
